import { useState } from "react";
import { MdAdd } from "react-icons/md";
import { toast } from "react-toastify";
import { useGetProductQuery } from "../../../features/api/productApi";
import { useGetSubCategoryQuery } from "../../../features/api/subcategoryApi";
import { useAddNewModelMutation } from "../../../features/api/modelApi";

const CrateUnit = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [sub_catName, setSubCategory] = useState(1);
  const [product_name, setProduct] = useState(1);
  const [model, setModel] = useState("");
  const [openingQty, setOpeningQty] = useState(0);

  const subCategories = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.brandData;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const [addNewModel] = useAddNewModelMutation();
  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const newProductModel = {
        open_qty: openingQty,
        model_name: model,
        subcategory_id: +sub_catName,
        product_id: +product_name,
      };
      const response = await addNewModel(newProductModel);
      if (response?.data) {
        // setIsOpen(false);
        // document.body.style.overflow = "auto";
        toast.success("Model created successfully...!!!");
        setModel("");
        setOpeningQty(0);
      } else if (response?.errors) {
        setIsOpen(false);
        toast.error("Model created error");
      }
    } catch (error) {
      console.error("Error creating data:", error);
    }
  };

  return (
    <div>
      <span
        onClick={openModal}
        className="flex items-center p-1 text-white rounded-sm bg-blue-500 font-medium text-sm cursor-pointer"
      >
        <MdAdd size={20} /> New Model
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-slate-200 p-6 rounded shadow-md lg:w-[400px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <h1 className="font-medium">Create Model</h1>
              <div className="card-body">
                <form
                  onSubmit={handleAdd}
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="flex flex-col gap-4 w-full">
                    <select
                      value={sub_catName}
                      onChange={(e) => setSubCategory(Number(e.target.value))}
                      className="border pl-1 h-8 bg-slate-50"
                    >
                      <option>--select--</option>
                      {subCategories?.map((sub) => (
                        <option key={sub?.id} value={sub?.id}>
                          {sub?.sub_catName}
                        </option>
                      ))}
                    </select>

                    <select
                      value={product_name}
                      onChange={(e) => setProduct(Number(e.target.value))}
                      className="border pl-1 h-8 bg-slate-50"
                    >
                      <option>--select--</option>
                      {products?.map((pro) => (
                        <option key={pro?.id} value={pro?.id}>
                          {pro?.product_name}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      value={model}
                      onChange={(e) => setModel(e.target.value)}
                      className="border pl-1 h-8 bg-slate-50"
                      placeholder="Enter Model Name..."
                    />
                    <input
                      type="text"
                      value={openingQty}
                      onChange={(e) => setOpeningQty(Number(e.target.value))}
                      className="border pl-1 h-8 bg-slate-50"
                      placeholder="Enter Quantity"
                    />
                  </div>
                  <button
                    type="submit"
                    className="bg-blue-500 text-white font-bold mt-4 px-2 rounded block m-auto"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CrateUnit;
